import {
  Box,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  styled,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { COLORS } from "colors/color";
import ChipInput from "components/Chips/chip";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { FieldTypography } from "StyledTypography/StyledTypography";
import CloseIcon from "@mui/icons-material/Close";
import { CancelButton } from "components/Buttons/Buttons";
import { NextButton } from "components/Buttons/Buttons";
import { InfoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import colors from "colors/color";
import { NewCancelButton } from "components/Buttons/Buttons";
import { NewCreateOfferButton } from "components/Buttons/Buttons";
import { Google, Microsoft } from "@mui/icons-material";
import SimpleEditor from "components/TextFields/SimpleEditor";

const theme = createTheme();
const apiUrl = process.env.REACT_APP_API_URL;
const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;
const apiUrlsoket = process.env.REACT_APP_API_URL_SOKET;

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
  },
});

const StyledDialogContent = styled(DialogContent)({
  padding: 0,
});

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: "Poppins",
    borderColor: "#00000033",
    backgroundColor: "#fff",
    transition: "border-color 0.4s ease, box-shadow 0.4s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "& .MuiOutlinedInput-input": {
      minHeight: "36px",
      padding: "8px 14px",
    },
  },
}));

// const StyledFormControl = styled(FormControl)({
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "10px",
//     "& fieldset": {
//       // borderColor: "#e0e0e0",
//     },
//     "&:hover fieldset": {
//       borderColor: "transparent",
//       // borderWidth: "2px",
//     },
//     "&:hover": {
//       transition: "0.3s ease",
//       // boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
//       // boxShadow: '0px 4px 20px rgba(0, 23, 231, 0.1)',
//       borderColor: '#0017E7',
//       // transition: 'all 0.3s ease',
//     },
//     "&.Mui-focused": {
//       boxShadow: "0px 0px 5px 0.4px rgba(0, 23, 231, 0.1)",
//       // boxShadow: '0px 4px 20px rgba(0, 23, 231, 0.1)',
//       borderColor: '#0017E7',
//       // transition: 'all 0.3s ease',
//       "& fieldset": {
//         borderColor: "transparent",
//         borderWidth: "2px",
//       },
//     },
//     "&.Mui-error": {
//       "&:hover, &.Mui-focused": {
//         boxShadow: "0px 0px 5px 0.4px rgba(0, 23, 231, 0.1)",
//         // boxShadow: '0px 4px 20px rgba(0, 23, 231, 0.1)',
//         // borderColor: '#0017E7',
//         // transition: 'all 0.3s ease',
//       },
//     },
//   },
// });
const StyledFormControl = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#0017E7",
      borderWidth: "1px",
    },
    "&:hover": {
      transition: "0.3s ease",
      boxShadow: "none",
    },
    "&.Mui-focused": {
      boxShadow: "none",
      borderColor: "#0017E7",
      borderWidth: "2px",
      "& fieldset": {
        borderColor: "transparent",
        borderWidth: "2px",
      },
    },
    "&.Mui-error": {
      "&:hover, &.Mui-focused": {
        boxShadow: "none",
        borderColor: "#d32f2f",
      },
    },
  },
});
const StyledDatePicker = styled(DatePicker)({
  "& .MuiOutlinedInput-root": {
    height: 56,
    borderRadius: "10px",
    fontFamily: "Poppins",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
  },
});

function EditPostDetailsDialog({
  setOpen,
  postTitle = "",
  setPostTitle = () => { },
  reference = "",
  setReference = () => { },
  accountType = "",
  setAccountType = () => { },
  postDescription = "",
  setPostDescription = () => { },
  offerType = "job",
  setOfferType = () => { },
  postRequirement = [],
  setPostRequirement = () => { },
  postDeadline = null,
  handleDateChange = () => { },
  handleNext = () => { },
  open = false,
  errors = {},
  showRef = false,
  dateError = "",
  setDateError = () => { },
  recruiterEmail = "",
  setRecruiterEmail = () => { },
  setErrors = () => { },

}) {
  const { t } = useTranslation();
  useEffect(() => {
    console.log("postRequirement:", recruiterEmail);
  }, [postRequirement]);

  // Log all props for debugging
  useEffect(() => {
    console.log("EditPostDetailsDialog Props:", {
      postTitle,
      postDescription: postDescription?.length > 100 ? `${postDescription.substring(0, 100)}... (${postDescription.length} chars)` : postDescription,
      postRequirement,
      postDeadline,
      offerType,
      reference,
      accountType,
      errors,
      open,
    });

    // Log full content length for debugging
    if (postDescription && postDescription.length > 0) {
      console.log(`Full postDescription length: ${postDescription.length} characters`);
      console.log('First 200 chars:', postDescription.substring(0, 200));
    }
  }, [
    postTitle,
    postDescription,
    postRequirement,
    postDeadline,
    offerType,
    reference,
    accountType,
    errors,
    open,
  ]);
  return (
    <StyledDialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="sm"
    >
      <Box
        sx={{
          width: "100%",
          height: 60,
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: " 1px solid #D9D9D9",
        }}
      >
        <DialogTitle
          sx={{
            fontSize: 20,
            fontWeight: 500,
            fontFamily: "Poppins",
            color: "#000",
          }}
        >
          {t("cardPost.updatePostTitle")}
        </DialogTitle>
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            mr: 3,
            color: "#000",
            border: "1px solid #D9D9D9",
            "&:hover": {
              color: "#000",
              backgroundColor: "#0084ff08",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <StyledDialogContent>
        <Stack spacing={3} margin={2}>
          <Typography
            sx={{
              color: colors.primary,
              fontSize: 15,
              fontFamily: "Poppins",
              fontWeight: "600",
            }}
          >
            {t("postDetailsDialog.postDetails")}
          </Typography>
          <Grid item xs={12} md={12}>
            <Typography
              sx={{
                color: "#0000004D",
                fontSize: "13px",
                fontFamily: "Poppins",
                fontWeight: 500,
              }}
            >
              {t("postDetailsDialog.postTitleLabel")}
            </Typography>
            <StyledTextField
              variant="outlined"
              value={postTitle}
              onChange={(event) => setPostTitle(event.target.value)}
              error={!!errors.postTitle}
              helperText={errors.postTitle}
              required
              fullWidth
            />
          </Grid>
          {showRef && (
            <>
              <Grid item xs={12} md={12}>
                <FieldTypography>
                  {t("postDetailsDialog.AccountTypeLabel")}
                </FieldTypography>

                <StyledFormControl fullWidth error={!!errors.accountType}>
                  <Select
                    labelId="account-type-label"
                    value={accountType}
                    onChange={(event) => setAccountType(event.target.value)}
                    required
                    sx={{
                      borderRadius: "8px",
                    }}
                  >
                    <MenuItem value="g">
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Google style={{ color: "#DB4437" }} />
                        Google Gmail
                      </Box>
                    </MenuItem>
                    <MenuItem value="m">
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Microsoft style={{ color: "#00A1F1" }} />
                        Microsoft Outlook
                      </Box>
                    </MenuItem>
                  </Select>
                  {errors.accountType && (
                    <FormHelperText>{errors.accountType}</FormHelperText>
                  )}
                </StyledFormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <FieldTypography>
                  {t("postDetailsDialog.recruiterEmailLabel")}
                </FieldTypography>
                <StyledTextField
                  variant="outlined"
                  value={recruiterEmail}
                  onChange={(event) => {
                    const email = event.target.value;
                    setRecruiterEmail(email);

                    // Basic email validation
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    const isValidEmailFormat = emailRegex.test(email);

                    // Account type specific validation
                    const isGmail = email.toLowerCase().endsWith("@gmail.com");
                    const isOutlook =
                      email.toLowerCase().endsWith("@outlook.com") ||
                      email.toLowerCase().endsWith("@hotmail.com");

                    let error = "";
                    if (!email && showRef) {
                      error = "Email is required";
                    } else if (email && !isValidEmailFormat) {
                      error = "Please enter a valid email address";
                    } else if (email && accountType === "g" && !isGmail) {
                      error = "Please enter a valid Gmail address";
                    } else if (email && accountType === "m" && !isOutlook) {
                      error = "Please enter a valid Outlook/Hotmail address";
                    }

                    // Update email error state
                    setErrors((prev) => ({
                      ...prev,
                      recruiterEmail: error,
                    }));
                  }}
                  error={!!errors.recruiterEmail}
                  helperText={errors.recruiterEmail}
                  placeholder={
                    accountType === "g"
                      ? "example@gmail.com"
                      : "example@outlook.com"
                  }
                  required={showRef}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Box sx={{ position: "relative" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#0000004D",
                        fontSize: "13px",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                      }}
                    >
                      {t("postDetailsDialog.referenceLabel")}
                    </Typography>
                    <Tooltip
                      title={
                        <Typography
                          sx={{
                            color: "#fff",
                            p: 1,
                            fontSize: "12px",
                            fontFamily: "Poppins",
                          }}
                        >
                          <span
                            style={{ color: "#ff6b6b", fontWeight: "bold" }}
                          >
                            {t("postDetailsDialog.tooltipImportant")}
                          </span>
                          <br />
                          {t("postDetailsDialog.tooltipMessage")}
                        </Typography>
                      }
                      placement="top"
                      arrow
                      sx={{ marginLeft: "auto" }}
                    >
                      <InfoIcon
                        sx={{
                          color: "#ff6b6b",
                          fontSize: "18px",
                          cursor: "pointer",
                          transition: "color 0.2s",
                          "&:hover": {
                            color: "#ff4757",
                          },
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <StyledTextField
                    variant="outlined"
                    value={reference}
                    onChange={(event) => setReference(event.target.value)}
                    error={!!errors.reference}
                    helperText={errors.reference}
                    required
                    fullWidth
                  />
                </Box>
              </Grid>
            </>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FieldTypography>
                {t("postDetailsDialog.offerTypeLabel")}
              </FieldTypography>

              <StyledFormControl fullWidth error={!!errors.offerType}>
                <Select
                  labelId="offer-type-label"
                  value={offerType}
                  onChange={(event) => setOfferType(event.target.value)}
                  required
                  sx={{
                    borderRadius: "8px",
                  }}
                >
                  <MenuItem value="job">
                    {t("postDetailsDialog.jobOption")}
                  </MenuItem>
                  <MenuItem value="internship">
                    {t("postDetailsDialog.internshipOption")}
                  </MenuItem>
                </Select>
                {errors.offerType && (
                  <FormHelperText>{errors.offerType}</FormHelperText>
                )}
              </StyledFormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FieldTypography>
                {t("postDetailsDialog.offerDeadlineLabel")}
              </FieldTypography>
              <Box sx={{ width: "95%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StyledDatePicker
                    value={postDeadline ? dayjs(postDeadline) : null}
                    onChange={handleDateChange}
                    format="DD-MM-YYYY"
                    minDate={dayjs().add(1, "day")} // Restricts selection to tomorrow or later
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: "outlined",
                        error: Boolean(dateError), // Highlight field if there's an error
                        helperText: dateError || "", // Display error message
                      },
                    }}
                    sx={{
                      height: "22px",
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography
              sx={{
                color: "#0000004D",
                fontSize: "13px",
                fontFamily: "Poppins",
                fontWeight: 500,
              }}
            >
              {t("postDetailsDialog.postDescriptionLabel")}
            </Typography>
            <SimpleEditor
              value={postDescription}
              onChange={(content) => setPostDescription(content)}
              placeholder="Enter post description..."
              maxLength={10000}
              error={!!errors.postDescription}
              helperText={errors.postDescription}
              minHeight="400px"
            />
          </Grid>



          <Grid item xs={12} md={12}>
            <FieldTypography>
              {t("postDetailsDialog.skillsLabel")}
            </FieldTypography>

            <ChipInput
              requirement={postRequirement}
              setRequirement={setPostRequirement}
            />
          </Grid>
        </Stack>
      </StyledDialogContent>
      <DialogActions sx={{ padding: 2, justifyContent: "flex-end", pr: 2 }}>
        <NewCancelButton onClick={() => setOpen(false)} variant="outlined">
          {t("postDetailsDialog.cancelButton")}
        </NewCancelButton>
        <NewCreateOfferButton variant="contained" onClick={handleNext}>
          {t("postDetailsDialog.nextButton")}
        </NewCreateOfferButton>
      </DialogActions>
    </StyledDialog>
  );
}

export default EditPostDetailsDialog;
